import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { CidadeModule } from '../../cidade';
import { PaisSharedModule } from '../../pais';

import { PessoaContatoModule } from '../contato';
import { PessoaEnderecoComponent } from './pessoa-endereco.component';
import { PessoaEnderecoFormComponent } from './form';
import { PessoaEnderecoUnicoComponent } from './unico';
import { PessoaEnderecoCidadeComponent } from './cidade';
import { PessoaEnderecoInfoCardComponent } from './info-card';


@NgModule({
    imports: [
        SharedModule,
        PessoaContatoModule,
        PaisSharedModule,
        CidadeModule
    ],
    declarations: [
        PessoaEnderecoComponent,
        PessoaEnderecoFormComponent,
        PessoaEnderecoUnicoComponent,
        PessoaEnderecoCidadeComponent,
        PessoaEnderecoInfoCardComponent
    ],
    exports: [
        PessoaEnderecoComponent,
        PessoaEnderecoFormComponent,
        PessoaEnderecoUnicoComponent,
        PessoaEnderecoCidadeComponent,
        PessoaEnderecoInfoCardComponent
    ]
})
export class PessoaEnderecoModule { }
